import { Text } from '@billy/design-system'
import { PropsWithChildren } from 'react'

interface DetailContentProps extends PropsWithChildren {
  value: string | number | undefined | null
}

export const DetailContent = ({ children, value }: DetailContentProps) => {
  if (!value) {
    return <Text>-</Text>
  }

  if (children) {
    return <span>{children}</span>
  }

  return (
    <Text alignment="left" colorVariant="primary" variant="bodySM" weight="bold">
      {value}
    </Text>
  )
}
